export const getCredentialDisplayName = (credential, lang) => {
  var _credential$metadata, _credential$metadata2;
  const defaultLanguage = 'en'; // todo: use a more reliable default language
  const metaData = (credential === null || credential === void 0 || (_credential$metadata = credential.metadata) === null || _credential$metadata === void 0 ? void 0 : _credential$metadata.find(meta => meta.language === lang)) || (credential === null || credential === void 0 || (_credential$metadata2 = credential.metadata) === null || _credential$metadata2 === void 0 ? void 0 : _credential$metadata2.find(meta => meta.language === defaultLanguage)) || {
    title: ''
  };
  return metaData.title;
};